import { BaseService } from '../../infra/base.service'
import type { FacebookRepository } from './facebook.repository'

export class FacebookService extends BaseService<null> {
    constructor(private rep: FacebookRepository) {
        super(rep)
    }

    async getAdsAccounts(facebookId: string, facebookToken: string) {
        return await this.rep.getAdsAccounts(facebookId, facebookToken)
    }
}
